var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app-main",attrs:{"id":"main"}},[_c('div',{staticClass:"page-content"},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1),_c('transition',{attrs:{"mode":"out-in","name":"fade-transform"}},[(!_vm.$route.meta.keepAlive)?_c('router-view',{key:_vm.key}):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }